export default function isExternalLink(href: string): boolean {
  return (
    /^(https?:\/\/(?!.*edx\.org)[^"]+)/i.test(href) &&
    !href.includes("localhost")
  );
}
